export const createSingleFlightApplicationLoader = <T>(request: () => Promise<T>) => {
  let inFlight: Promise<T> | null = null;

  return () => {
    if (!inFlight) {
      const trackedRequest = request().finally(() => {
        if (inFlight === trackedRequest) {
          inFlight = null;
        }
      });

      inFlight = trackedRequest;
    }

    return inFlight;
  };
};
